import { FORSENDELSE, OPRETTELSE } from '@/modules/TV/settings';
import { TV_BOKS_RECURRENT_PRICE } from '../utilities/settings';
import {
    campaign_types,
    GetRecurrentConfig,
    ICampaign,
    product_type,
} from './campaign-shared';
import { TVPackageItem, VaelgSelvTVPackage } from './sows';

export default class TVVaelgSelvCampaign implements ICampaign {
    product_type: product_type = 'tvvaelgselv';
    campaign_type: campaign_types;
    product: VaelgSelvTVPackage | null;
    basePackage: TVPackageItem | null;

    constructor(
        campaign_type: campaign_types,
        product: VaelgSelvTVPackage | null,
        basePackage: TVPackageItem | null
    ) {
        this.campaign_type = campaign_type;
        this.product = product;
        this.basePackage = basePackage;
    }

    getCustomRules() {
        return undefined;
    }

    getNumberOfCampaignMonths() {
        return undefined;
    }

    getNumberOfBindingMonths() {
        return 6;
    }

    getInitialFee(): number {
        return 0;
    }

    getPreviousInitialFee(): number {
        return OPRETTELSE;
    }

    getRecurrent(config?: GetRecurrentConfig): number {
        return (
            this.product!.price +
            this.basePackage!.price +
            (config && config.hasTvBoks ? TV_BOKS_RECURRENT_PRICE : 0)
        );
    }

    getTotalRecurrentInBindingPeriod(hasTvBoks?: boolean): number {
        return (
            this.getRecurrent({ hasTvBoks }) * this.getNumberOfBindingMonths()
        );
    }

    getTotalPriceInBindingPeriod(hasTvBoks?: boolean): number {
        return (
            this.getTotalRecurrentInBindingPeriod(hasTvBoks) +
            this.getShipmentFee() +
            this.getInitialFee()
        );
    }

    getPreviousRecurrent(): number | undefined {
        return undefined;
    }

    getShipmentFee(): number {
        return 0;
    }

    getTotalInitialPrice(): number {
        return (
            this.getRecurrent() + this.getInitialFee() + this.getShipmentFee()
        );
    }
}
